import { z } from 'zod';
export const savedViewEntityTypeSchema = z.enum(['lead', 'contact', 'company', 'opportunity', 'task']);
export const savedViewVisibilitySchema = z.enum(['private', 'team', 'everyone']);
export const createSavedViewSchema = z.object({
    entityType: savedViewEntityTypeSchema,
    name: z.string().trim().min(1).max(80),
    filters: z.record(z.string(), z.unknown()).default({}),
    sort: z.array(z.string()).default([]),
    columns: z.array(z.string()).default([]),
    visibility: savedViewVisibilitySchema.default('private'),
    isDefault: z.boolean().default(false),
    /** Hex color for the Sidebar's colored dot; cosmetic only. */
    color: z.string().regex(/^#[0-9A-Fa-f]{6}$/).optional(),
    /** Pins this view to the Sidebar's own "Saved views" section. */
    showInSidebar: z.boolean().default(false),
});
export const updateSavedViewSchema = createSavedViewSchema.omit({ entityType: true }).partial();
export const savedViewResponseSchema = z.object({
    id: z.string().uuid(),
    entityType: savedViewEntityTypeSchema,
    name: z.string(),
    filters: z.record(z.string(), z.unknown()),
    sort: z.array(z.string()),
    columns: z.array(z.string()),
    visibility: savedViewVisibilitySchema,
    isDefault: z.boolean(),
    ownerId: z.string().uuid(),
    color: z.string().nullable(),
    showInSidebar: z.boolean(),
});
//# sourceMappingURL=schemas.js.map